import type { User } from '../store/slices/authSlice';

export type UserWithImpersonation = User & { impersonatedBy?: string };

/** Super admin using their own token (platform operator), not impersonating a tenant user. */
export function isPlatformOnlySuperAdmin(user: User | null): boolean {
  if (!user || user.role !== 'SUPER_ADMIN') return false;
  return !(user as UserWithImpersonation).impersonatedBy;
}
